import ReportsDetails from './ReportsDetails';

export default ReportsDetails;
